import React from 'react'

function LoaderScreen() {
  return (
     <div className='loader-screen-bg'>


        <div className="loader-screen-main">
           <div className="loader-admin"></div> 
        </div>

    </div>
  )
}

export default LoaderScreen